import { render } from "./SubmitPendingVehicleModal.vue?vue&type=template&id=3b6daa3b"
import script from "./SubmitPendingVehicleModal.vue?vue&type=script&lang=js"
export * from "./SubmitPendingVehicleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__